import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { AiOutlineInfoCircle } from "react-icons/ai";

const InfoTooltip = ({ text }) => {
  return (
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip>{text}</Tooltip>}
    >
      <span style={{ marginLeft: "6px", cursor: "pointer" }}>
        <AiOutlineInfoCircle size={14} color="#6c757d" />
      </span>
    </OverlayTrigger>
  );
};

export default InfoTooltip;